import { useSetAtom } from 'jotai';

import { conversionPoints } from '@/components/Modals/context/ModalRoutingContext';
import {
  subscribeModalOpenAtom,
  subscribeModalUnlockFeatureAtom,
} from '@/components/Modals/Subscribe/atoms';
import { recordConversion } from '@/utils/analytics/conversion';

import type { ModalConversionPoints } from '@/components/Modals/shared-types';

/**
 * Opens the standalone Subscribe modal. Sibling of the Download Gateway —
 * the gateway's `useAssetUpsellTrigger` owns the asset-paywall flow (which
 * writes the upsell atom and shows a different UI). This hook only toggles
 * the Subscribe modal's open atom and registers the conversion point.
 */
export function useSubscribeModal() {
  const setSubscribeModalOpen = useSetAtom(subscribeModalOpenAtom);
  const setUnlockFeature = useSetAtom(subscribeModalUnlockFeatureAtom);

  function openSubscribeModalWithConversion(
    conversionPoint: ModalConversionPoints,
    /** Names the locked feature in the heading — see the atom (DEV-6610). */
    unlockFeature?: string
  ) {
    recordConversion({ source: conversionPoints[conversionPoint] });
    // Always written, so an opener that names no feature clears the last one
    // rather than inheriting its heading.
    setUnlockFeature(unlockFeature ?? null);
    setSubscribeModalOpen(true);
  }

  return { openSubscribeModalWithConversion };
}
